var map = {
	"./close.svg": 9580,
	"./down.svg": 4996,
	"./filter.svg": 7110,
	"./minus.svg": 96,
	"./play.svg": 9878,
	"./plus.svg": 8392,
	"./search.svg": 5460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3216;